import { render } from "./svg25mAP.vue?vue&type=template&id=5edf1791&scoped=true"
import script from "./svg25mAP.vue?vue&type=script&lang=js"
export * from "./svg25mAP.vue?vue&type=script&lang=js"

import "./svg25mAP.vue?vue&type=style&index=0&id=5edf1791&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edf1791"]])

export default __exports__